export const GET_LISTS = "GET_LISTS";
export const SET_LISTS = "SET_LISTS";

export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const SET_SUBSCRIPTIONS = "SET_SUBSCRIPTION";
export const UPDATE_SUBSCRIPTIONS = "UPDATE_SUBSCRIPTIONS";
